<template>
  <md-icon
    v-if="visible"
    class="chat-leadership-badge md-icon md-icon-font md-theme-default"
    :title="CHAT_LEADERSHIP_BADGE_TITLE"
  >{{ CHAT_LEADERSHIP_BADGE_ICON }}</md-icon>
</template>

<script>
import {
  CHAT_LEADERSHIP_BADGE_ICON,
  CHAT_LEADERSHIP_BADGE_TITLE,
  userHasLeadershipRole,
} from '../helper/chatLeadershipBadge';

export default {
  name: 'LeadershipBadgeIcon',
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      CHAT_LEADERSHIP_BADGE_ICON,
      CHAT_LEADERSHIP_BADGE_TITLE,
    };
  },
  computed: {
    visible() {
      return userHasLeadershipRole(this.user);
    },
  },
};
</script>

<style lang="scss">
.chat-leadership-badge {
  font-size: 16px !important;
  width: 16px !important;
  min-width: 16px !important;
  height: 16px;
  margin: 0 0 0 4px !important;
  color: #f97316 !important;
  flex-shrink: 0;
  vertical-align: middle;
}
</style>
